export default "/dist/files/icon_journaux_blanc.7312da5afef53b100bd4d5e0abaa8159.svg";